import { Request } from '../../common/api/requests';
import { type ApiResult, type BaseParams, type PostParams, type WebsocketAuthToken } from '../../common/structs/';
import { links } from '../../links';

export async function token(params: BaseParams & PostParams): Promise<ApiResult<WebsocketAuthToken>> {
    return Request.postRequest<WebsocketAuthToken>({
        ...params,
        target: links.ws().token(),
    });
}
